import { getApiClient } from './authApiClient';

const client = () => getApiClient('tenant');

// Tenant-facing: the caller's own tenant requests. Admins may pass a tenantId to view another.
export const getInsuranceRequests = async (tenantId) =>
  (await client().get('/insurance/requests', { params: tenantId ? { tenantId } : {} })).data;

export const createInsuranceRequest = async (data) =>
  (await client().post('/insurance/requests', data)).data;

export const getInsuranceOnboarding = async (tenantId) =>
  (await client().get('/insurance/onboarding', { params: tenantId ? { tenantId } : {} })).data;

export const saveInsuranceOnboarding = async (tenantId, onboarding) =>
  (await client().put('/insurance/onboarding', { tenantId, onboarding })).data;

export const uploadInsuranceOnboardingDocument = async (tenantId, file, metadata = {}) => {
  const response = await client().post('/insurance/onboarding/documents/upload', file, {
    params: {
      tenantId,
      filename: file.name,
      mimeType: file.type || 'application/octet-stream',
      title: metadata.title || file.name,
      category: metadata.category || 'other',
      product: metadata.product || undefined,
    },
    headers: { 'Content-Type': 'application/octet-stream' },
  });
  return response.data;
};

export const getInsuranceOnboardingDocumentDownload = async (tenantId, id) =>
  (await client().get(`/insurance/onboarding/documents/${id}/download`, { params: tenantId ? { tenantId } : {} })).data;

export const generateInsuranceApplication = async (tenantId, payload) =>
  (await client().post('/insurance/onboarding/generate', { tenantId, ...payload })).data;

export const getInsuranceGeneratedApplicationDownload = async (tenantId, id) =>
  (await client().get(`/insurance/onboarding/generated/${id}/download`, { params: tenantId ? { tenantId } : {} })).data;

// Admin/distributor cross-tenant views.
export const getAllInsuranceRequests = async (tenantIds) =>
  (await client().get('/insurance/requests/all', {
    params: tenantIds && tenantIds.length ? { tenantIds: tenantIds.join(',') } : {},
  })).data;

export const updateInsuranceRequestStatus = async (id, status, patch = {}) =>
  (await client().put(`/insurance/requests/${id}/status`, { status, ...patch })).data;

export const sendInsuranceRequestReminder = async (id, data = {}) =>
  (await client().post(`/insurance/requests/${id}/remind`, data)).data;

// Distributor raising cover on a client's behalf — same endpoint, with the client tenantId.
export const createInsuranceRequestForClient = async (tenantId, data) =>
  (await client().post('/insurance/requests', { ...data, tenantId })).data;
